import React from 'react';

const Input = ({ isCapslock, subject, label, handleChange, toggleVisible, name, checkCapsLock }) => (
  <div className={'form-group has-float-label ' + (isCapslock === true ? 'has-error' : '')}>
    <span className="eye-icon">
      <i
        className={`fa ${subject.visible ? 'fa-eye' : 'fa fa-eye-slash'}`}
        onClick={() => { toggleVisible(name)} }
      />
    </span>
    <input
      type={subject.visible ? 'text' : 'password'}
      value={subject.value}
      onKeyDown={checkCapsLock}
      onChange={(e) => { handleChange(name, e) } }
      autoComplete="off"
      style={{backgroundColor: subject.value.length >= 8 ? '#e5f6d1' : 'white'}}
      className="form-control"
    />
    <label>{label}</label>
    <span className="password-icon" />
  </div>
);

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/form/input.js